<template>
  <div class="table-container">
    <table class="data-table">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="item.id || index">
          <td v-for="column in columns" :key="`${item.id}-${column.key}`">
            <!-- Image cell -->
            <div v-if="column.type === 'image'" class="image-cell">
              <img 
                v-if="item[column.key]" 
                :src="item[column.key]" 
                :alt="item.course_name || 'Image'" 
                class="thumbnail" 
                @click="$emit('preview', item[column.key], 'image')"
              />
              <span v-else class="no-image">No image</span>
            </div>
            
            <!-- Actions cell -->
            <div v-else-if="column.type === 'actions'" class="actions-cell">
              <button class="action-btn view-btn" @click="$emit('view', item.id)" title="View details">
                <i class="fas fa-eye"></i>
              </button>
              <button class="action-btn edit-btn" @click="$emit('edit', item, index)" title="Edit">
                <i class="fas fa-edit"></i>
              </button>
              <button class="action-btn delete-btn" @click="$emit('delete', item.id, index)" title="Delete">
                <i class="fas fa-trash"></i>
              </button>
            </div>
            
            <!-- Default cell with formatter -->
            <span v-else>
              {{ column.formatter ? column.formatter(item[column.key]) : item[column.key] || 'N/A' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  emits: ['view', 'edit', 'delete', 'preview']
}
</script>

<style scoped>
.table-container {
  overflow-x: auto;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.data-table th, 
.data-table td {
  text-align: left;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.data-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #343a40;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table tbody tr {
  transition: background-color 0.2s ease;
}

.data-table tbody tr:hover {
  background-color: #f8f9fa;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

.image-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.thumbnail {
  width: 3rem;
  height: 3rem;
  object-fit: cover;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.thumbnail:hover {
  transform: scale(1.1);
}

.no-image {
  color: #6c757d;
  font-size: 0.875rem;
}

.actions-cell {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #f8f9fa;
}

.view-btn {
  color: #3498db;
}

.view-btn:hover {
  background-color: #e3f2fd;
}

.edit-btn {
  color: #f39c12;
}

.edit-btn:hover {
  background-color: #fff8e1;
}

.delete-btn {
  color: #e74c3c;
}

.delete-btn:hover {
  background-color: #ffebee;
}

@media (max-width: 768px) {
  .data-table th, 
  .data-table td {
    padding: 0.75rem 0.5rem;
    font-size: 0.875rem;
  }
  
  .action-btn {
    width: 2rem;
    height: 2rem;
  }
}
</style> 